export enum ItemsTypes {
  Pack = "Pack",
  Video = "Video",
  Pdf = "PDF",
  Event = "Event",
  Flow = "Flow",
  Group = "Group",
  User = "User",
  EmbeddedVideo = "Embedded Video",
  Link = "Link",
  SCORM = "SCORM",
}
